import LOCAL_KEYS, {
    parseLocalStorageJSON,
  } from "../../../helpers/Localstorage";
  import { RequestBody } from "../../WebServiceManager/RequestBody";
  import { RequestHeader } from "../../WebServiceManager/RequestHeader";

  export default class ReportsRequestBody {
    reportsProjectsByIdRequest(method) {
        const header = new RequestHeader();
        const request = new RequestBody(
          method,
          header.applicationJson(parseLocalStorageJSON(LOCAL_KEYS.ACCESS_TOKEN))
        );
        return request;
    }
    budgetReportByProjectIdRequest(method) {
      const header = new RequestHeader();
      const request = new RequestBody(
        method,
        header.applicationJson(parseLocalStorageJSON(LOCAL_KEYS.ACCESS_TOKEN))
      );
      return request;
  }

    generateReportRequest(method) {
      const header = new RequestHeader();
      const request = new RequestBody(
        method,
        header.applicationJson(parseLocalStorageJSON(LOCAL_KEYS.ACCESS_TOKEN))
      );
      return request;
    }
  }